import { uuid } from '@10000/common'
import { useBreakpoints, useRequest } from '@10000/react'
import { useBackground, useShell } from '../layout'
import { Box, H3, MadeByPodAndHive } from '../widgets'
import { ModeCard } from '.'

export const SelectMode = ({ active }) => {
  const request = useRequest('tenant')
  const { mobile } = useBreakpoints()

  useShell({ active, mode: 'navigate' })
  useBackground().set({ active, background: undefined })

  const start = solo => () => {
    const id = uuid()
    return request('squizCreated', {
      id,
      teamId: 'free',
      options: {
        solo,
        presenterParticipates: true,
        tutorial: true,
        guides: true,
        consensus: !solo,
        questionCount: solo ? 3 : 2
      }
    })
  }

  return (
    <Box
      column
      fullWidth
      fullHeight
      gap={32}
      overflowY="auto"
      alignItems="center"
      justifyContent={'space-between'}
      p="80px 32px 32px 32px"
    >
      {!mobile && <Box />}

      <Box column alignItems="center" gap={40}>
        <Box alignItems="center" gap={8}>
          {!mobile && <img src={`https://fonts.gstatic.com/s/e/notoemoji/latest/1f44b/512.gif`} alt="waving" width={64} height={64} />}
          <H3 align="center">Choose your mode</H3>
        </Box>

        <Box gap={40} column={mobile}>
          <ModeCard
            pillText="Optimal experience"
            duration="60min"
            title="Team Mode"
            subtitle="I can practice with my team"
            text="Experience Shivoo exactly as intended. Assemble your team and have each player join using their own device."
            buttonText="Start Team Mode"
            features={[
              '2 questions (Standard and Consensus mode)',
              'Access to your results and analytics',
              'Compare to global data',
              'Compare Standard and Consensus mode'
            ]}
            onClick={start(false)}
            background="var(--blue)"
            tickBackground="white"
            tickColor="black"
          />

          <ModeCard
            duration="30min"
            title="Solo Mode"
            subtitle="I can practice on my own"
            text="No team? Try Solo Mode! For best results, imagine playing with your colleagues."
            buttonText="Start Solo Mode"
            features={[
              '3 questions (Standard mode only)',
              'Access to your results and analytics',
              'Compare to global data'
            ]}
            onClick={start(true)}
            background="white"
            color="black"
            tickBackground="black"
            tickColor="white"
          />
        </Box>
      </Box>

      <MadeByPodAndHive />
    </Box>
  )
}

